'use strict';
import * as $ from 'jquery';
import { TweenMax, TimelineLite, Power0, Power2} from 'gsap';
import 'slick-carousel';

let mv: string = '#mainvisual';
let logo: string = '#mainvisual .logo';
let catchcopy: string = '#mainvisual .catch';
let items_list = '#mainvisual .service-list';
let items: string = '#mainvisual .service-list__item';
let $items: JQuery = $(items);//保存用
let itemplay: any;




let photoInit = function () {
    const $photoList: JQuery = $('#data .photo-list');
    const ps: PhotoSlide = new PhotoSlide($photoList);
    ps.checkItem();
    ps.slide();
    $(window).on('resize', { self: ps }, ps.resize);
}


//写真スライド用Class
class PhotoSlide {
    /**
     *
     * @param target {JQuery}
     * @param itemWidth {Number}
     * @param itemNum {Number}
     */
    target: JQuery;
    items: JQuery;//アイテムを格納
    itemNum: number;//アイテム数
    itemWidth: number;//横幅
    targetTM: TimelineLite;
    speed:number;
    num:number;//複製する数
    constructor(_target) {
        this.target = _target;
        this.items = this.target.children('li');
        this.itemNum = this.items.length;
        this.itemWidth = this.items.width() * this.itemNum;
        this.targetTM = new TimelineLite();
        this.speed = 3;
        this.num = 0;
        //console.log(Math.ceil(this.itemWidth));
    }
    /**
    * スライドを始める
    */
    slide(){
        this.targetTM.clear();
        this.targetTM.fromTo(this.target, this.speed * this.itemNum, 
            {
                x:0
            },
            {
            ease: Power0.easeNone,
            x: this.itemWidth * -1,
            onComplete:this.slideComplete,
            onCompleteParams: [this]
        });
    }
    slideComplete(self){
        self.target.children('li').each(function (i) {
            if (i < self.itemNum) {
                $(this).remove();
            }
        });
        self.items.clone().appendTo(self.target);
        //console.log(self.slide);
        self.slide();
    }

    /**
    * 幅にあわせて複製・削除
    */
    checkItem() {
        let ww: number = window.outerWidth;
        let num: number = Math.ceil(ww / this.itemWidth);
        if (this.num !== num ){
            this.target.empty();
            for (let i: number = 0; i <= num; i++) {
                this.items.clone().appendTo(this.target);
            }
            this.itemWidth = this.target.children('li').width() * this.itemNum;
            this.num = num;
            this.slide();
        }
    }
    /**
    * リサイズ時
    */
    resize(e) {
        let self: PhotoSlide = e.data.self;
        self.checkItem();      
    }
}


function itemSliderInit() {
    var slider: Carousel = new Carousel($('#service .service-list'));
}

class Carousel {
    target:JQuery;
    constructor(_target) {
        this.target = _target;
        this.init();
    }
    init() {
        this.target.slick({
            autoplay: true,
            variableWidth: true,
            arrows: false,
            centerMode: true,
            autoplaySpeed: 2000
        });
    }
}

//スクロールアニメ
let scrollAnime = function () {
    $(window).on('scroll',function(){
        $('#mainContainer .block').each(function () {
            let elemOffset: number = $(this).offset().top;
            let scrollPos: number = $(window).scrollTop();
            let wh = $(window).height();
            if (scrollPos > elemOffset - wh + (wh / 4)) {
                $(this).addClass('isShow');
            }
        });
    });
}

//loading後
let loadingInit = function () {
    $(window).on('load',function(){
        //
        //scrollAnime();

        //写真スライドの初期化
        photoInit();
        //アイテムスライダーの初期化
        itemSliderInit();
        
    });
}

loadingInit();